<nz-page-header class="site-page-header" nzTitle="Pilots"
  nzSubtitle="{{this._state.pilotList.length}}/{{this._state.drones}}">
</nz-page-header>

<nz-list class="demo-loadmore-list" [nzLoading]="initLoading">
  <nz-list-item *ngFor="let item of this._state.pilotList;let i = index">
    <ng-container *ngIf="!item.loading">
      <nz-list-item-meta nzAvatar="../../../../assets/images/pilot.jpg" nzDescription="{{ item.name }}">
        <nz-list-item-meta-title>
          {{ item.area }}<br />
          <code>{{strm_url}}{{this._state.username}}_{{i+1}}</code>
        </nz-list-item-meta-title>
      </nz-list-item-meta>

      <ul nz-list-item-actions>
        <nz-list-item-action><a (click)="edit(item)">edit</a></nz-list-item-action>
        <nz-list-item-action><a (click)="deletePilotSubmit(item)">delete</a></nz-list-item-action>
      </ul>
    </ng-container>
    <nz-skeleton *ngIf="initLoading" [nzAvatar]="true" [nzActive]="true" [nzTitle]="false" [nzLoading]="true">
    </nz-skeleton>
  </nz-list-item>
  <div class="loadmore" nz-list-load-more>
    <button nz-button *ngIf="!initLoading && this._state.pilotList.length < this._state.drones" (click)="addPilot()">Add
      Pilot</button>
  </div>
</nz-list>


<nz-modal [(nzVisible)]="addPilotisVisible" nzTitle="Add Pilot" [nzFooter]="modalFooter">

  <form nz-form [formGroup]="pilotForm" (ngSubmit)="addPilotSubmit()">
    <nz-form-item>
      <nz-form-label nzFor="name" nzRequired>
        <span>
          Pilot Name
        </span>
      </nz-form-label>
      <nz-form-control nzErrorTip="Please input your name!">
        <input nz-input id="name" formControlName="name" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzFor="name" nzRequired>
        <span>
          Flying Area
        </span>
      </nz-form-label>
      <nz-form-control nzErrorTip="Please input area!">
        <input nz-input id="area" formControlName="area" />
      </nz-form-control>
    </nz-form-item>
    <!-- 
    <nz-form-item nz-row class="register-area">
      <nz-form-control [nzSpan]="14" [nzOffset]="6">
        <button nz-button nzType="primary">Register</button>
      </nz-form-control>
    </nz-form-item> -->
  </form>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="addPilotisVisible = false">Cancel</button>
    <button nz-button nzType="primary" (click)="addPilotSubmit()">Submit</button>
  </ng-template>

</nz-modal>


<nz-modal [(nzVisible)]="editPilotisVisible" nzTitle="Edit Pilot" [nzFooter]="editmodalFooter">

  <form nz-form [formGroup]="pilotForm" (ngSubmit)="updatePilotSubmit()">
    <nz-form-item>
      <nz-form-label nzFor="name" nzRequired>
        <span>
          Pilot Name
        </span>
      </nz-form-label>
      <nz-form-control nzErrorTip="Please input your name!">
        <input nz-input id="name" formControlName="name" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzFor="name" nzRequired>
        <span>
          Flying Area
        </span>
      </nz-form-label>
      <nz-form-control nzErrorTip="Please input area!">
        <input nz-input id="area" formControlName="area" />
      </nz-form-control>
    </nz-form-item>
    <!-- 
    <nz-form-item nz-row class="register-area">
      <nz-form-control [nzSpan]="14" [nzOffset]="6">
        <button nz-button nzType="primary">Register</button>
      </nz-form-control>
    </nz-form-item> -->
  </form>

  <ng-template #editmodalFooter>
    <button nz-button nzType="default" (click)="editPilotisVisible = false">Cancel</button>
    <button nz-button nzType="primary" (click)="updatePilotSubmit()">Update</button>
  </ng-template>

</nz-modal>
